import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=61c1b4ca&scoped=true&"
import script from "./Guidance.vue?vue&type=script&lang=js&"
export * from "./Guidance.vue?vue&type=script&lang=js&"
import style0 from "./Guidance.vue?vue&type=style&index=0&id=61c1b4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1b4ca",
  null
  
)

export default component.exports